import { render, staticRenderFns } from "./settingGroup.vue?vue&type=template&id=0347c4c2&"
import script from "./settingGroup.vue?vue&type=script&lang=js&"
export * from "./settingGroup.vue?vue&type=script&lang=js&"
import style0 from "./settingGroup.vue?vue&type=style&index=0&id=0347c4c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports